import React, {Component} from 'react';
import {connect} from 'react-redux';
import Anchor from "../../../../dashboardNew/objects/Anchor";

class MemberItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            isThanks: false
        }
    }

    render() {

        const {member, index} = this.props,
                src = member.picture;

        return (

            <div className={`col-12 col-sm-6 col-md-6 col-xl-3 base-card profile-card`} key={ index }>
                <Anchor path={`/members/${ member.id }`} anchorClass="card-inner" internal>
                    <div className="theme-profile-head"></div>
                    <div className="profile-card-picture" style={{ backgroundImage : `url(${ src })` }}></div>
                    <div className="theme-profile-body">
                        <h3 className="heading-three">
                            { member.first_name } <br/> { member.last_name }
                        </h3>
                            <p className="body-copy">
                                { member.industry && member.industry.name ?
                                    member.industry.name : 'Unknown Industry'
                                }
                            </p>
                            <p className="body-copy location">
                                <img src="/images/icons-new/location.svg" alt="location icon"
                                     className="location-icon"/>
                                { member.region && member.region.name ?
                                    member.region.name : 'Unknown Location'
                                }
                            </p>
                        <button className="theme-button">Go to profile</button>
                    </div>
                </Anchor>
            </div>
        );
    };
}

export default connect()(MemberItem);



// WEBPACK FOOTER //
// src/client/components/site/features/members/pages/MemberItem.js